export enum OrderBy {
  Weight = 'weight',
  CreatedAt = 'createdAt',
  Score = 'score',
}
